// SPEC-PATROL-OVERDUE-ALERT-V1 (D-505) ITEM_2: 巡回間隔が空いた店舗の取得。
//   ひろ指示「巡回日が4日間隔空いたらアラート出したい。場所は管理ハブの『未対応の報告』と同じ場所」。
//   サーバ側 fn_store_patrol_gaps がライブ計算して jsonb 単一行で返す(1000 行トラップ回避・D-464 踏襲)。
//   booth_alerts に行は作らない。巡回すれば次の取得で自動的に消える(解消ロジックを持たない = 静かに死なない)。
import { supabase } from '../lib/supabase'
import { logger } from '../lib/logger'

// ITEM_4: 閾値はマジックナンバーにしない。全店一律(店舗別カスタマイズは NON_GOALS)。
// D-1115: 坂本さん(STAFF-01)の要望で 4 → 5 日に変更。RPC へ渡す値と管理ハブの「n日以上」の表示の両方がこれを見る。
// D-1122: ここは既定値。実際の値はアラート設定(app_config の alert_patrol_overdue_days)。ランチャーは設定値を thresholdDays で渡す。
export const PATROL_OVERDUE_THRESHOLD_DAYS = 5

/**
 * 最終巡回から閾値日数以上空いた稼働店舗を取得する。
 * @param {{ thresholdDays?: number }} opts
 * @returns {Promise<{ meta: object, rows: Array }>} rows は days_since 降順。失敗時は空配列(画面をブロックしない)。
 */
export async function fetchPatrolOverdueStores({ thresholdDays = PATROL_OVERDUE_THRESHOLD_DAYS } = {}) {
  const { data, error } = await supabase.rpc('fn_store_patrol_gaps', { p_threshold_days: thresholdDays })
  if (error) {
    logger.error?.('ERR-PATROL-OVERDUE', { message: error.message })
    return { meta: {}, rows: [] }
  }
  const payload = data || {}
  return { meta: payload.meta || {}, rows: Array.isArray(payload.rows) ? payload.rows : [] }
}

// 表示用の経過日数ラベル。1 行に収める短い表記にする(管理ハブは 390px 幅)。
export function overdueLabel(row) {
  const d = Number(row?.days_since)
  if (!Number.isFinite(d)) return ''
  return `${d}日`
}
